import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { QuestionManagementService } from '../../../Services/question-management/question-management.service';
import { AnswerChoiceNoteModel } from 'src/app/Models/AnswerChoiceNote';
import { FormBuilder, FormGroup } from '@angular/forms';
import { VAddAnswerChoiceNote } from 'src/app/Validators/Validators';
import { ToastrService } from 'ngx-toastr';
import { MATHtest } from '../../../../assets/js/fullscreen';
import { RenderMathjax } from '../../../../assets/js/fullscreen';
@Component({
  selector: 'app-fa-answer-choice-note',
  templateUrl: './answer-choice-note.component.html',
  styleUrls: ['./answer-choice-note.component.css'],
})
export class AnswerChoiceNoteComponent implements OnInit {
  AddAnswerChoiceNoteform: FormGroup;
  @Input() selectedQuestionById: any;
  @Input() AnswerChoiceNotePopup: boolean;
  @Input() EditAnswerChoiceNotePopup: boolean;
  @Input() AnswerChoiceNotePopup1: boolean;
  @Input() EditAnswerChoiceNotePopup1: boolean;
  InsertAnswerChoiceNote: AnswerChoiceNoteModel;
  @Output() AddAnswerchoiceNoteclose: EventEmitter<any> =
    new EventEmitter<any>();
  @Output() EditAnswerchoiceNoteclose: EventEmitter<any> =
    new EventEmitter<any>();
  @Output() EditAnswerchoiceNoteclose1: EventEmitter<any> =
    new EventEmitter<any>();
  @Output() EditAddAnswerchoiceNoteclose: EventEmitter<any> =
    new EventEmitter<any>();
  @Output() REdirecttoRightAnswerfromnote: EventEmitter<any> =
    new EventEmitter<any>();
  Buttonflg: string;
  RTEFlag: string = 'AnswerChoiceNote';

  constructor(
    public service: QuestionManagementService,
    private fb: FormBuilder,
    private toastr: ToastrService
  ) {}

  InitializeForm() {
    this.AddAnswerChoiceNoteform = this.fb.group({
      Answer_Choice_Note_Text: ['', VAddAnswerChoiceNote],
    });
  }

  ngOnInit() {
    this.InitializeForm();
    if (this.selectedQuestionById.Answer_Choice_ID != null) {
      this.GetAnswerChoiceNoteByID(this.selectedQuestionById.Answer_Choice_ID);
      this.Descriptioncount();
    } else {
      this.GetAnswerChoiceNoteByID(null);
      this.Descriptioncount();
    }
  }

  AnswerChoiceNoteContent: string;
  GetAnswerChoiceNoteContent(data: any) {
    this.AnswerChoiceNoteContent = data;
    //if(this.QuestionBodyContent!=null)
    this.AddAnswerChoiceNoteform.controls['Answer_Choice_Note_Text'].setValue(
      this.AnswerChoiceNoteContent
    );
  }
  AnswerChoiceNoteList: any;
  AnswerChoice: any;
  QuestionBodyget: string;
  GetAnswerChoiceNoteByID(data: any) {
    this.service.GetAnserChoiceNoteByID({ AnswerChoiceID: data }).subscribe(
      (i: any) => {
        this.AnswerChoice = i;
        this.AnswerChoiceNoteList = this.AnswerChoice.AnswerChoiceNoteList;
        if (
          this.AnswerChoiceNoteList != null &&
          this.AnswerChoiceNoteList != undefined
        ) {
          if (this.AnswerChoiceNoteList.length > 0) {
            this.AnswerChoiceNoteList.forEach(
              (
                currentValue: {
                  Answer_Choice_Note_Text: string;
                  Hint_Ind: any;
                },
                index: any
              ) => {
                if (currentValue.Hint_Ind == 'N') {
                  if (currentValue.Answer_Choice_Note_Text != null) {
                    this.AddAnswerChoiceNoteform.controls[
                      'Answer_Choice_Note_Text'
                    ].setValue(currentValue.Answer_Choice_Note_Text);
                    this.QuestionBodyget = currentValue.Answer_Choice_Note_Text;

                    this.AnswerChoiceNoteContent =
                      currentValue.Answer_Choice_Note_Text;
                  }
                }
              }
            );
          }
        }

        // if(this.AnswerChoiceNoteList!=null){
        //   if(this.AnswerChoiceNoteList.Answer_Choice_Note_Body_Text!=null){
        // this.AddAnswerChoiceNoteform.controls['Answer_Choice_Note_Body_Text'].setValue(this.AnswerChoiceNoteList[0].Answer_Choice_Note_Body_Text);
        // }
        // else{
        //   this.AddAnswerChoiceNoteform.controls['Answer_Choice_Note_Body_Text'].setValue(this.AnswerChoiceNoteList[0].Answer_Choice_Note_Body_Text);
        // }

        // this.selectedQuestionList.map((obj) => {
        // obj.checkedflag = false;
        // return obj;
        // })
        // }).catch((e:any)=>{
        //   this.AnswerChoiceNoteList=null;
        // });
      },
      (error) => {
        console.log(error);
      }
    );
  }

  save_submitted: boolean = false;
  AddAnswerChoiceResponse: any;
  index: Number;
  // Questionid:string;
  modalclose: any;
  SaveAnswerChoiceNote() {
    this.validate1 = false;
    if (this.AddAnswerChoiceNoteform.valid) {
      this.InsertAnswerChoiceNote = this.AddAnswerChoiceNoteform.value;
      this.InsertAnswerChoiceNote.QuestionID =
        this.selectedQuestionById.Question_ID;
      this.InsertAnswerChoiceNote.Question_Status_ID =
        this.selectedQuestionById.Question_Status_ID;
      this.InsertAnswerChoiceNote.Answer_Choice_Id =
        this.selectedQuestionById.Answer_Choice_ID;
      this.InsertAnswerChoiceNote.HintInd = 'N';
      if (
        this.AnswerChoiceNoteList != null &&
        this.AnswerChoiceNoteList != undefined
      ) {
        if (this.AnswerChoiceNoteList.length > 0) {
          this.AnswerChoiceNoteList.forEach(
            (
              currentValue: {
                Answer_Choice_Note_Id: any;
                Answer_Choice_Note_Text: string;
                Hint_Ind: any;
              },
              index: any
            ) => {
              if (currentValue.Hint_Ind == 'N') {
                if (currentValue.Answer_Choice_Note_Text != null) {
                  this.InsertAnswerChoiceNote.Answer_Choice_Note_Id =
                    currentValue.Answer_Choice_Note_Id;
                } else {
                  this.InsertAnswerChoiceNote.Answer_Choice_Note_Id = null;
                }
              }
            }
          );
        } else {
          this.InsertAnswerChoiceNote.Answer_Choice_Note_Id = null;
        }
      } else {
        this.InsertAnswerChoiceNote.Answer_Choice_Note_Id = null;
      }

      this.service
        .CreateOrModifyAnswerChoiceNote(this.InsertAnswerChoiceNote)
        .subscribe(
          (i: any) => {
            this.AddAnswerChoiceResponse = i;
            if (this.AddAnswerChoiceResponse.Message == 'Success') {
              this.toastr.success('Saved Successfully', 'Success',{timeOut: 500});
              this.save_submitted = false;
              // console.log(this.EditQuestionBodyPopup,'EditQuestionBodyPopup');
              if (this.AnswerChoiceNotePopup) {
                this.AddAnswerchoiceNoteclose.emit(this.modalclose);
              } else if (this.EditAnswerChoiceNotePopup) {
                this.EditAddAnswerchoiceNoteclose.emit(this.modalclose);
              } else if (this.EditAnswerChoiceNotePopup1) {
                this.EditAnswerchoiceNoteclose1.emit(this.modalclose);
              } else {
                this.EditAnswerchoiceNoteclose.emit(this.modalclose);
              }
              //this.QuestionBodyclose.emit();
              //this.getQuestionByID(this.AddQuestionResponse.Value)
              //this.Questionid=this.AddQuestionResponse.Value;
              //this.AddQuestionform.controls['QuestionId'].setValue(this.AddQuestionResponse.Value);
              //this.AddQuestionform.controls['QuestionId'].setValue(this.AddQuestionResponse.Value);
              // }
            } else {
              this.toastr.error(this.AddAnswerChoiceResponse.Message);
            }
            //  }).catch((e:any)=>{
            //    this.AddAnswerChoiceResponse=e;
            //    this.toastr.error(this.AddAnswerChoiceResponse.statusText);
            //    this.save_submitted=false;
            //  }
            //  )
          },
          (error) => {
            this.AddAnswerChoiceResponse = error;
            this.toastr.error(this.AddAnswerChoiceResponse.Message);
            this.save_submitted = false;
            console.log(error);
          }
        );
    }
  }

  Descriptionvaluelength: any;
  DescriptionMaxlength: any;
  Descriptioncount() {
    this.DescriptionMaxlength = 4000;
    if (
      this.AddAnswerChoiceNoteform.controls.Answer_Choice_Note_Text.value !=
        '' &&
      this.AddAnswerChoiceNoteform.controls.Answer_Choice_Note_Text.value !=
        null
    ) {
      if (
        this.AddAnswerChoiceNoteform.controls.Answer_Choice_Note_Text.value
          .length > 0
      ) {
        this.Descriptionvaluelength =
          this.AddAnswerChoiceNoteform.controls.Answer_Choice_Note_Text.value.length;
      } else {
        this.Descriptionvaluelength = 0;
      }
    } else {
      this.Descriptionvaluelength = 0;
    }
  }

  validate: boolean = false;
  latexeditlist: any[] = [];
  GetLatexBodyContent(data: any) {
    // this.latexeditlist.push({latextext:data.latex,equation:data.mathjax,cursor:data.cursor});
    // console.log(this.latexeditlist,'latexeditlist')
    this.latexeditlist = data;
    console.log(this.latexeditlist, 'latexeditlist');
  }

  Indicator: boolean = false;
  RemoveLatexBodyContent(data: any) {
    console.log(data, 'removecursor');
    for (var j = 0; j < this.latexeditlist.length; j++) {
      console.log(data, j, this.latexeditlist[j].cursor);
      if (this.latexeditlist[j].cursor == data) {
        //this.Indicator=true;
        this.latexeditlist.splice(j, 1);
        break;
        //this.Indicator=true;
        //break;
      }
      // if(this.Indicator)
      // {
      // this.latexeditlist[j].cursor=this.latexeditlist[j].cursor-1;
      // }
    }
  }

  Editlatex(data: any, index: any) {
    console.log(data, 'Editlatex');
    let rendermathjax = RenderMathjax(data);
    console.log(rendermathjax, 'mathjax');
    this.latexeditlist[index].latex = data;
    this.latexeditlist[index].mathjax = rendermathjax;
  }

  copyInput(index: any) {
    this.copyMessage(this.latexeditlist[index].latex);
  }

  copyMessage(val: string) {
    document.body.oncopy = function () {
      return true;
    };
    const selBox = document.createElement('textarea');

    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = val;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
    //document.body.oncopy = function() { return false; }
  }

  Cancel() {
    this.Buttonflg = 'Cancel';
    if (this.service.ScreenTrackName == 'app-fa-question-add-edit') {
      this.Buttonflg = 'Cancel';
    }
    // if(this.service.ScreenTrackName=='app-fa-question-preview'){
    //   this.Buttonflg='Redirecttopreview';
    // }
    if (this.service.ScreenTrackName == 'app-fa-answer-choice-add-edit') {
      this.Buttonflg = 'RedirecttoChoice';
    }

    // if(this.QuestionBodyget==this.AnswerChoiceNoteContent){
    if (!this.validate1) {
      if (this.Buttonflg == 'Cancel') {
        if (this.AnswerChoiceNotePopup) {
          this.AddAnswerchoiceNoteclose.emit(this.modalclose);
        } else if (this.EditAnswerChoiceNotePopup) {
          this.EditAddAnswerchoiceNoteclose.emit(this.modalclose);
        } else if (this.EditAnswerChoiceNotePopup1) {
          this.EditAnswerchoiceNoteclose1.emit(this.modalclose);
        } else {
          this.EditAnswerchoiceNoteclose.emit(this.modalclose);
        }
      } else if (this.Buttonflg == 'RedirecttoChoice') {
        this.REdirecttoRightAnswerfromnote.emit('app-fa-answer-choice-note');
      }
    } else {
      this.Alertpopup();
    }
  }

  //cancel alert
  validate1: boolean;
  GetLatexBodyContentchanges(data: boolean) {
    this.validate1 = data;
  }

  alertpopupflag: boolean;
  Alertpopup() {
    this.alertpopupflag = !this.alertpopupflag;
  }

  Savecontent() {
    if (this.alertpopupflag) {
      this.Alertpopup();
    }
    this.validate1 = false;
    this.SaveAnswerChoiceNote();
  }

  close() {
    if (this.alertpopupflag) {
      this.Alertpopup();
    }
    if (this.service.ScreenTrackName == 'app-fa-question-add-edit') {
      this.Buttonflg = 'Cancel';
    }
    // if(this.service.ScreenTrackName=='app-fa-question-preview'){
    //   this.Buttonflg='Redirecttopreview';
    // }
    if (this.service.ScreenTrackName == 'app-fa-answer-choice-add-edit') {
      this.Buttonflg = 'RedirecttoChoice';
    }
    if (this.Buttonflg == 'Cancel') {
      if (this.AnswerChoiceNotePopup) {
        this.AddAnswerchoiceNoteclose.emit(this.modalclose);
      } else if (this.EditAnswerChoiceNotePopup) {
        this.EditAddAnswerchoiceNoteclose.emit(this.modalclose);
      } else if (this.EditAnswerChoiceNotePopup1) {
        this.EditAnswerchoiceNoteclose1.emit(this.modalclose);
      } else {
        this.EditAnswerchoiceNoteclose.emit(this.modalclose);
      }
    } else if (this.Buttonflg == 'RedirecttoChoice') {
      this.REdirecttoRightAnswerfromnote.emit('app-fa-answer-choice-note');
    }
  }

  ///Edit latex

  editlatexbutton: boolean;
  getlatex: string;
  currentindex: number;
  Editlatexbutton(index: any) {
    this.currentindex = index;
    this.Editlatexpopup();
    this.getlatex = this.latexeditlist[index].latex;
  }
  Editlatexpopup() {
    this.editlatexbutton = !this.editlatexbutton;
  }

  closelatexpopup() {
    if (this.latexeditlist[this.currentindex].latex == this.getlatex) {
      if (this.editlatexbutton) {
        this.Editlatexpopup();
      }
    } else {
      this.latexAlertpopup();
    }
  }

  Savelatex() {
    this.latexeditlist[this.currentindex].latex = this.getlatex;
    this.Editlatex(this.getlatex, this.currentindex);
    this.copyMessage(this.getlatex);
    if (this.editlatexbutton) {
      this.Editlatexpopup();
    }
  }
  LatexpopupCancel() {
    if (this.latexeditlist[this.currentindex].latex == this.getlatex) {
      if (this.editlatexbutton) {
        this.Editlatexpopup();
      }
    } else {
      this.latexAlertpopup();
    }
  }

  latexalert: boolean;
  latexAlertpopup() {
    this.latexalert = !this.latexalert;
  }

  Savelatexcontent() {
    this.latexAlertpopup();
    this.Savelatex();
  }
  closelatex() {
    this.latexAlertpopup();
    this.Editlatexpopup();
  }
}
